import { ReactElement } from 'react'
import { Button, Text } from '@raskrask-dk/rr-components'
import { StyledPickButtons } from '../../companycard/styles'
import { useTranslation } from 'react-i18next'

import CompanyCardPage from '../../companycard'
import { PropsWeekdayTemplate } from './props'
import { ShortWeekDayString } from '@raskrask-dk/bookingflow-state-machine'
import { generalUtilities } from '@raskrask-dk/raskrask-utils'
const WeekdayTemplate = ({
    weekDays,
    currentStep,
    helpers,
    onClickWeekDay,
    dataCy,
}: PropsWeekdayTemplate): ReactElement => {
    const { t } = useTranslation()

    const weekdaysOptions: {
        label: string
        value: ShortWeekDayString
        longName: string
    }[] = [
        {
            value: 'MON',
            label: t('common:days.monday.short'),
            longName: t('common:days.monday.long'),
        },
        {
            value: 'TUE',
            label: t('common:days.tuesday.short'),
            longName: t('common:days.tuesday.long'),
        },
        {
            value: 'WED',
            label: t('common:days.wednesday.short'),
            longName: t('common:days.wednesday.long'),
        },
        {
            value: 'THU',
            label: t('common:days.thursday.short'),
            longName: t('common:days.thursday.long'),
        },
        {
            value: 'FRI',
            label: t('common:days.friday.short'),
            longName: t('common:days.friday.long'),
        },
    ]

    return (
        <CompanyCardPage
            choosenText={
                weekDays
                    ? weekdaysOptions
                          .filter((day) => weekDays.includes(day.value))
                          .map((day) => {
                              return generalUtilities.capitalizeFirstLetter(
                                  day.longName
                              )
                          })
                    : []
            }
            dataCy={dataCy}
            onClickNext={helpers.goToNextStep}
            open={currentStep === 2}
            setOpen={() => helpers.setStep(currentStep === 2 ? 7 : 2)}
            title={t('companylead.weekday.header')}
        >
            <Text>{t('companylead.weekday.text')}</Text>
            <StyledPickButtons
                css={{
                    gridTemplateColumns: 'repeat(auto-fit, minmax(50px, 1fr))',
                }}
            >
                {weekdaysOptions.map((day, index) => (
                    <Button
                        active={
                            weekDays &&
                            weekDays.filter((e) => e === day.value).length > 0
                        }
                        data-cy={`weekday_${index + 1}`}
                        key={index}
                        onClick={() => onClickWeekDay(day.value)}
                        size="large"
                        variant="option"
                    >
                        {day.label.toUpperCase()}
                    </Button>
                ))}
            </StyledPickButtons>
        </CompanyCardPage>
    )
}

export default WeekdayTemplate
